import { render, staticRenderFns } from "./techStep.vue?vue&type=template&id=4b1c0b08&scoped=true&"
import script from "./techStep.vue?vue&type=script&lang=js&"
export * from "./techStep.vue?vue&type=script&lang=js&"
import style0 from "./techStep.vue?vue&type=style&index=0&id=4b1c0b08&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c0b08",
  null
  
)

export default component.exports